import { render, staticRenderFns } from "./SRCCreateOrUpdate.vue?vue&type=template&id=8cddf946&"
import script from "./SRCCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SRCCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports